import * as moment from 'moment';
import * as Constants from '@/constants';
/* eslint-disable */

export default class {
  constructor(student) {
    const totalReimbursableMinutes = student.form.totalReimbursableMinutes;
    const serviceInfo = student.form.serviceInformation;
    const sessionDate = moment(serviceInfo.sessionDate, 'MM-DD-YYYY').format('YYYY-MM-DD');
    // validations will make sure medicaid exists if needLevel === skills
    this.providerUserId = student.providerUserId;
    this.providerHUserId = student.providerHUserId;
    this.providerId = student.providerId;
    this.supportId = student.serviceId;
    this.objectiveNotes = student.form.serviceInformation.objectiveNotes;
    this.supportTypeId = student.serviceTypeId;
    this.absentType = serviceInfo.absentType;
    this.absentReason = serviceInfo.absentReason;
    this.absentAlternative = serviceInfo.absentAlternative;
    this.absentAlternativeDesc = serviceInfo.absentAlternativeDesc;
    this.noServiceNotifFlag = serviceInfo.noServiceNotifFlag;
    this.groupSize = serviceInfo.groupSize;
    this.groupType = serviceInfo.groupType;
    this.credentialType = serviceInfo.credentialType;
    this.studentId = student.studentId;
    this.hStudentId = student.hStudentId;
    this.sessionDate = sessionDate;
    this.sessionTime = serviceInfo.sessionTime || null;
    this.sessionMinutes = serviceInfo.sessionMinutes ? Number(serviceInfo.sessionMinutes) : null;
    this.serviceDelivered = serviceInfo.serviceDelivered;
    this.locationId = serviceInfo.location.locationId || null;
    this.locationOther = serviceInfo.locationOther || null;
    this.deliveryMode = serviceInfo.deliveryMode;
    this.roomName = serviceInfo.roomName;
    this.notes = serviceInfo.notes;
    this.nextSessionFocus = serviceInfo.nextSessionFocus;
    this.nextSessionGoal = serviceInfo.nextSessionGoal;
    this.providerLocation = serviceInfo.providerLocation;
    this.licenseAttestDate = serviceInfo.licenseAttestDate;
    this.licenseAttestUserId = serviceInfo.licenseAttestUserId;
    this.licenseAttestName = serviceInfo.licenseAttestName;
    this.supervisorUserId = serviceInfo.supervisorUserId;
    this.supervisorName = serviceInfo.supervisorName;
    this.supervisorCredential = serviceInfo.supervisorCredential;
    this.supervisorDate = serviceInfo.supervisorDate;
    this.otSessionBehaviors = serviceInfo.otSessionBehaviors;
    this.studentBehavior = serviceInfo.studentBehavior;
    this.otSessionProgressCodes = serviceInfo.otSessionProgressCodes;
    this.progressAssessment = serviceInfo.progressAssessment;
    this.otSessionObjectives = serviceInfo.otSessionObjectives;
    /** TODO - TECHDEBT-4: Pattern for service implementation should be reviewed **/
    this.otSessionImplementations = serviceInfo.otSessionImplementations.slice(0, 3);
    this.sessionNotes = serviceInfo.sessionNotes;

    // Clean up progress code values
    for (let i = 0; i < this.otSessionProgressCodes.length; i++) {
      for (let j = this.otSessionProgressCodes[i].type.length - 1; j >=0; j--) {
        if (!this.otSessionProgressCodes[i].type[j].checked) {
          // this.otSessionProgressCodes[i].type[j].checked = 'false';
        }
        else if (this.otSessionProgressCodes[i].type[j].checked) {
          // this.otSessionProgressCodes[i].type[j].checked = 'true';
        }
      }
    }

    for (let i = 0; i < this.otSessionProgressCodes.length; i++) {
      for (let j = this.otSessionProgressCodes[i].measurable.length - 1; j >= 0; j--) {
          if (this.otSessionProgressCodes[i].measurable[j].value1 === '' && this.otSessionProgressCodes[i].measurable[j].value2 === '') {
            // this.otSessionProgressCodes[i].measurable.splice(j, 1);
          }
      }
    }

    for (let i = 0; i < this.otSessionProgressCodes.length; i++) {
      for (let j = this.otSessionProgressCodes[i].assistance.length - 1; j >= 0; j--) {
        if (this.otSessionProgressCodes[i].assistance[j].value1 && this.otSessionProgressCodes[i].assistance[j].type === "NONE" ) {
          this.otSessionProgressCodes[i].assistance[j].value1 = "none";
        }
        else if (!this.otSessionProgressCodes[i].assistance[j].value1 && this.otSessionProgressCodes[i].assistance[j].type === "NONE" ) {
          // this.otSessionProgressCodes[i].assistance.splice(j, 1);
        }
        else if (this.otSessionProgressCodes[i].assistance[j].value1 === '' && this.otSessionProgressCodes[i].assistance[j].value2 === '') {
          // this.otSessionProgressCodes[i].assistance.splice(j, 1);
        }
      }
    }

    // unused field
    this.serviceDocumentation = null;
    // unused field
    this.hardToFill = null;
    this.verified = false;
    this.locId = null;
    this.rfpId = null;
    // clear out fields that are hidden when stu/provider is absent
    if (Constants.IS_ABSENT(serviceInfo.absentType)) {
      this.serviceDelivered = null;
      this.sessionTime = null;
      this.sessionMinutes = null;
      this.deliveryMode = null;
      this.roomName = null;
      this.providerLocation = null;
      this.otSessionBehaviors = null;
      this.otSessionObjectives = null;
      this.otSessionImplementations = null;
      this.otSessionProgressCodes = null;
      this.sessionNotes = null;
      this.nextSessionFocus = null;
      this.nextSessionGoal = null;
    }
    if (serviceInfo.deliveryMode !== Constants.IN_PERSON) {
      this.roomName = null;
    }
    if (serviceInfo.deliveryMode !== Constants.TELEPRACTICE) {
      this.providerLocation = null;
    }
    // set medicaid information if it exists
    this.medicaid = Constants.IS_SD_REIMBURSABLE(serviceInfo.serviceDelivered) && totalReimbursableMinutes > 0;
    if (!Constants.IS_ABSENT(serviceInfo.absentType) && !Constants.IS_CONSULTATION_SERVICE(student)) {
      this.medicaidMinutes = student.form.totalReimbursableMinutes;
      this.medicaidSessions = student.form.medicaid.map((procedure) => {
        return {
          ...procedure,
          studentId: student.studentId,
          hStudentId: student.hStudentId,
          providerUserId: student.providerUserId,
          providerHUserId: student.providerHUserId,
          procedureDate: sessionDate
        };
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/service-log-submission-class.js